export default function About() {
  return (
    <div className="page-shell">
      <div className="max-w-3xl">
        <h1 className="section-heading">About ADSPERIANX SOLUTIONS</h1>
        <p className="section-subheading">
          A Malaysia-based boutique software firm — focused on quality work we&apos;re proud to
          deliver.
        </p>
      </div>

      <div className="mt-10 grid gap-10 sm:mt-12 lg:grid-cols-2">
        <div className="space-y-6 text-base font-semibold leading-relaxed text-slate-600 sm:text-lg">
          <p>
            ADSPERIANX SOLUTIONS is a boutique software firm that partners closely with clients
            to build dependable digital products — from customer-facing websites to internal
            management systems.
          </p>
          <p>
            Every engagement is hands-on. We take time to understand how your business actually
            works, then craft software that fits — using modern tools like React, Node.js, and
            cloud deployment on AWS. You get direct access, honest advice, and solutions built to
            last.
          </p>
        </div>

        <div className="rounded-2xl border border-slate-200 bg-slate-50 p-6 sm:p-8">
          <h2 className="text-xl font-bold text-brand-900 sm:text-2xl">How we work</h2>
          <ul className="mt-6 space-y-4 text-base font-semibold text-slate-600 sm:text-lg">
            <li className="flex gap-3">
              <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-brand-500" />
              <span>Listen deeply — your goals, users, and constraints come first.</span>
            </li>
            <li className="flex gap-3">
              <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-brand-500" />
              <span>Build deliberately — proven tools, clean code, no unnecessary complexity.</span>
            </li>
            <li className="flex gap-3">
              <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-brand-500" />
              <span>Stay close — from launch through ongoing support as your partner.</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
